import React, { useState, useEffect, useContext } from 'react'
import Link from 'next/link'
import Error from 'next/error'
import dynamic from 'next/dynamic'
import { Button, Spinner } from "@heroui/react"
import { useRouter } from 'next/router'

import Layout from '../../../components/layout'

import { UserContext } from '../../../contexts/user-context'
import useChallenge from '../../../hooks/use-challenge'
import useChallengeStatus from '../../../hooks/use-challenge-status'
import useLeaders from '../../../hooks/use-leaders'
import useGroupResults from '../../../hooks/use-group-results'

const Map = dynamic(() => import('../../../components/map-v2'), { ssr: false })

const EmbedMap = () => {
  const router = useRouter()
  const { id, hide_btn } = router.query

  const userHook = useContext(UserContext)
  const user = userHook.user

  const challengeHook = useChallenge(id)
  const challenge = challengeHook.challenge

  const challengeStatusHook = useChallengeStatus(user.token, id)
  const challengeStatus = challengeStatusHook.challenge
 
  const [isIframe, setIsIframe] = useState(false)

  useEffect(() => {
    if (window.location !== window.parent.location) {
      setIsIframe(true)
    }
  }, [])

  let leaders = []
  let groupResults = []
  let progressPoints = []
  
  const leaderResults = useLeaders(challenge.id, user.token)
  if (leaderResults) {
    leaders = leaderResults.data
  }

  groupResults = useGroupResults(challenge.id && challenge.group.type === 'team' ? challenge.group : undefined, user.token)
  
  let fullyLoaded = groupResults.loaded && !leaderResults.loading

  if (fullyLoaded && challenge.id && challenge.isTeamChallenge && challengeStatus.teamResults) {
    if (challenge.group.type === 'team') {
      progressPoints = groupResults.progressPoints
    } else {
      let d = challengeStatus.teamResults.distance
      let p = challengeStatus.teamResults.pointGoal
      let dur = challengeStatus.teamResults.duration
      if (!challenge.isRank && challenge.measure === 'distance' && d > challenge.distance) d = challenge.distance
      if (!challenge.isRank && challenge.measure === 'pointGoal' && p > challenge.pointGoal) d = challenge.pointGoal
      if (!challenge.isRank && challenge.measure === 'durationGoal' && dur > challenge.durationGoal) d = challenge.durationGoal
      const temp = {
        fullname: 'Team Progress',
        isTeamName: true,
        distance: d,
        points: p,
        duration: dur
      }
      if (challenge.map && challenge.map.name) temp.fullname = challenge.map.name
      if (challenge.map && challenge.map.icon) temp.photo = challenge.map.icon
      if (challenge.map && challenge.map.iconStyle) temp.style = challenge.map.iconStyle
      progressPoints = [temp]
    }
  } else if (fullyLoaded && leaders) {
    progressPoints = leaders
  }

  let map
  if (challenge.id && challenge.map && challenge.map.waypoints) {
    map = challenge.map
  } else if (challenge.id && challenge.group.map && challenge.group.map.waypoints) {
    map = challenge.group.map
  }

  if (challenge.id && challenge.map && challenge.map.useChallengeDistance && (challenge.isRank || challenge.measure !== 'distance')) {
    delete map.useChallengeDistance
  }

  if (id && !challengeHook.loading && !challenge.id) return <Error statusCode={404} />
  
  return (
    <Layout
        title={`${challenge.id ? challenge.challengeName : 'Awesome Challenge'} - (powered by Challenge Hound)`}
        description={challenge.challengeDesc}
        keywords={challenge.challengeDesc}
        noRobots={true}>
        <main>
            {(map && challenge.id) && <div className='w-screen h-screen'>
              <Map 
                map={map} 
                challengeGoal={challenge[challenge.measure]} 
                challengeMeasure={challenge.measure} 
                progressPoints={progressPoints} 
                points={challenge.points} 
                user={{
                  id: challenge.isTeamChallenge ? challenge.id : user.id,
                  imperial: user.imperial
                }}
              />
            </div>}

            {!fullyLoaded && <div className='flex justify-center items-center w-screen h-screen'><Spinner size='xl' /></div>}
            {(fullyLoaded && challengeHook.challenge.id && (!map || !map.waypoints)) && <div style={{ marginTop: '30px', textAlign: 'center' }}>No map set for this challenge.</div>}
            
            {!hide_btn && <div className='absolute top-2 right-2'>
              {!isIframe && <Link href={`/challenge/[id]`} as={`/challenge/${challenge.id}`}>
                <Button size='sm' color='primary' >View Challenge</Button>
              </Link>}
              {isIframe && <a href={`https://www.challengehound.com/challenge/${challenge.id}`} target='_new'>
                <Button size='sm' color='primary'>View Challenge</Button>
              </a>}
            </div>}
            
            <div className='absolute top-2 left-2'>
              
                {!isIframe && <Link href={`/challenges`} as={`/challenges`}><img className='w-[40px] h-[40px]' src='/favicon.png' /></Link>}
                {isIframe && <a href={`https://www.challengehound.com`} target='_new'><img className='w-[40px] h-[40px]' src='/favicon.png' /></a>}
              
            </div>
        </main>
      </Layout>
  );
}

export default EmbedMap
